/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, Input } from "@angular/core";
import { AbstractModalComponent } from "../../../common/commondialog/abstract-modal.component";

@Component({
   standalone: false,
   selector: "clip-ft-help-dialog",
   templateUrl: "./clipboard-filetransfer-help-dialog.component.html",
   styles: [
      `
         /deep/ .modal.show .modal-dialog {
            width: 451.89px;
         }
      `
   ]
})
export class ClipFTHelpDialogComponent extends AbstractModalComponent {
   @Input() public title;
   @Input() public msg;
   @Input() public modKey;
}
